export class ClassicType {
  id: any;
  label?: string;
  value?: string;
  constructor(id, label) {
    this.id = id;
    this.label = label;
  }
  public static GetMultipleDropdownSettings = () => {
    return {
      singleSelection: false,
      selectAllText: 'Select All',
      unSelectAllText: 'UnSelect All',
      idField: 'id',
      textField: 'label',
      itemsShowLimit: 5,
      allowSearchFilter: true,
    }
  };
}
